import { RowMiddle } from 'layout/Components/Row'
import styled from 'styled-components'
import { Icons } from 'svgs'
import theme from 'theme'
import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import TransText from 'UIKit/Text/TransText'
import { ICommitmentsControl } from 'views/Payment/MobilePayment/types'

const PaymentCommitmentsBar: React.FC<BoxProps & { commitmentsControl: ICommitmentsControl }> = ({
  commitmentsControl,
  ...props
}) => {
  return (
    commitmentsControl.isShowCommitmentBar && (
      <StyledCommitments onClick={commitmentsControl.toggleCommitment} {...props}>
        <RowMiddle gap="8px">
          <Box minWidth="20px" width="20px" height="20px">
            <Icons.ProtectIcon color={theme.colors.backgroundAlt13} width="100%" height="100%" />
          </Box>
          <TransText textAlign="left" color="text_primary" fontWeight={500} small>
            View HunnyPlay's Commitments
          </TransText>
        </RowMiddle>
      </StyledCommitments>
    )
  )
}

const StyledCommitments = styled(Box)`
  width: 100%;
  padding: 12px;
  background: #13b96c26;
  height: var(--pm-trigger-height);
  border-radius: var(--pm-trigger-radius);

  display: flex;
  justify-content: space-between;
  cursor: pointer;

  &:hover {
    background: #13b96c33;
  }

  ${({ theme }) => theme.mediaQueries.md} {
    padding: 8px;
  }
`
export default PaymentCommitmentsBar
